// extracted by mini-css-extract-plugin
export default {"issues":"CommitIssues_issues__UojSa","issue":"CommitIssues_issue__jqF7N"};